import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { SimpleChanges } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-table-regular-manual-rostering',
  templateUrl: './table-regular-manual-rostering.component.html',
  styleUrls: ['./table-regular-manual-rostering.component.css']
})
export class TableRegularManualRosteringComponent implements OnInit {

  @Input('tableCols') cols;
  @Input('tableData') data;
  @Input('tableDataType') tableType;
  @Input() selectedEmployee;
  @Input() availableCapacity;
  @Output() selectedData = new EventEmitter();
  public dataSource;
  public selection = new SelectionModel(true, []);
  public availableTable:boolean=true;
  checked: boolean = false;
  constructor() { }

  public disabled: boolean = false
  public mainCheck: boolean = false
  // mohandasss --
  capsCount = 4
  selectCapsCont = 0


  get keys() {
    return this.cols.map(({ key }) => key);
  }
  ngOnInit(): void {
    this.dataSource = new MatTableDataSource(this.data);
    console.log(this.availableCapacity);
    console.log(this.data);
    console.log(this.cols);
    console.log(this.capsCount, this.data.length)
    if (this.capsCount < this.data.length) {

      alert("Vehicle set capacity greterthen employee count so select all Checkbox is disabled")
      this.mainCheck = true
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.data) {
      this.dataSource = new MatTableDataSource(changes.data.currentValue);
      //this.selectedDataList();
      this.selectedDataList();
    }
  }
  /* select all table data */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.data.forEach((row) => this.selection.select(row));
    console.log(this.selection);
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.data.length;
    return numSelected === numRows;
  }
  isNumber(o): boolean {
    return !isNaN(o - 0) && o !== null && o !== '' && o !== false;
  }
  /* selected Data List */
  selectedDataList() {
    let indexes = [];
    this.data.filter((e, i) => {
      if (this.tableType == 'employeeTable') {
        if (this.selectedEmployee.length > 0) {
          this.selectedEmployee.filter((item) => {
            if (item.employeeID == e.employeeID) {
              if (indexes.indexOf(i) == -1) {
                indexes.push(e);
              }
            }
          });
          if (indexes.length > 0) {
            this.selection.clear();
            indexes.forEach((i) => this.selection.select(i));
          }
        }
        if (indexes.length == 0) {
          this.selection.clear();
          this.masterToggle();
        }
      }
    });
  }
  sendSelectedData() {
    let parent = this;
    let sendData = [];
    this.selection.selected.forEach((e) => {
      sendData.push(e);
    })
    if (this.tableType == 'employeeTable') {
      //  this.selectedEmp.emit(this.selection.selected);
      const send = {
        type: 'employeeTable',
        data: sendData,
      };
      this.selectedData.emit(send);
    }
  }


  // mohanda--------------------------------------------------------
  singleSlect(val, i) {
    // alert(this.capsCount >= 1)
    // console.log(val, val.checked, i, this.data, this.selection)
    if (this.capsCount == 1) {
      this.data[i]['checked'] = true
      this.disabled = true
    }
    if (val.checked) {
      if (this.capsCount >= 1) {
        this.capsCount--
        this.data[i]['checked'] = true
        this.checked = true
      
      } else {
        // this.disabled = false
        this.data[i]['checked'] = false
      }

    } else {
      this.capsCount++
        this.disabled = false

    }
  }
  setAllCheckBox(event) {
    console.log(this.capsCount, this.data.length, event)
    if (event.checked) {
      if (this.capsCount > this.data.length) {
        this.checked = true
      }
    } else {
      this.checked = false
      this.mainCheck = false
    }
  }
  dis() {
    alert()
  }
}
